var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "game" },
    [
      _vm._m(0),
      _c(
        "v-row",
        _vm._l(_vm.games, function (game, index) {
          return _c("v-col", { key: index, attrs: { cols: "12", md: "6" } }, [
            _c(
              "div",
              {
                staticClass: "game-item",
                on: {
                  click: function ($event) {
                    return _vm.gameClick(game)
                  },
                },
              },
              [
                _c("div", { staticClass: "game-item__image" }, [
                  _c("img", {
                    attrs: {
                      src: game.icon.replace(
                        "https://vgplay.vn/uploads/",
                        "https://img.vgplay.vn/vgplay/"
                      ),
                      alt: "",
                    },
                  }),
                ]),
                _c("div", { staticClass: "game-item__text text-left" }, [
                  _vm._v(" " + _vm._s(game.name) + " "),
                  _c("span", { staticClass: "game-item__type d-block" }, [
                    _vm._v(_vm._s(game.type)),
                  ]),
                ]),
              ]
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "game__title" }, [
      _c("img", {
        attrs: {
          src: require("../assets/icons/game.svg"),
          alt: "",
          srcset: "",
        },
      }),
      _vm._v(" Chọn game "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }